function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1964(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 20.01,
    height: 9.44,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.18
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.005,
    y: 4.72,
    fontFamily: "Arial"
  }, "\n        Keweenaw\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 9.44,
    width: 20.01,
    height: 13.16,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.1933333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.005,
    y: 16.02,
    fontFamily: "Arial"
  }, "\n        Oscoda\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 22.6,
    width: 20.01,
    height: 15.93,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.99125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.005,
    y: 30.565,
    fontFamily: "Arial"
  }, "\n        Kalkaska\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 38.53,
    width: 20.01,
    height: 16.51,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.06375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.005,
    y: 46.785000000000004,
    fontFamily: "Arial"
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 55.05,
    width: 20.01,
    height: 17.1,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.5545454545454547
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.005,
    y: 63.599999999999994,
    fontFamily: "Arial"
  }, "\n        Montmorency\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 72.14,
    width: 20.01,
    height: 17.82,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.455
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.005,
    y: 81.05,
    fontFamily: "Arial"
  }, "\n        Luce\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 89.96,
    width: 20.01,
    height: 21.18,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.0025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.005,
    y: 100.55,
    fontFamily: "Arial"
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 111.14,
    width: 20.01,
    height: 21.52,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.3350000000000004
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.005,
    y: 121.9,
    fontFamily: "Arial"
  }, "\n        Alcona\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 132.66,
    width: 20.01,
    height: 23.51,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.2233333333333336
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.005,
    y: 144.415,
    fontFamily: "Arial"
  }, "\n        Missaukee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 156.17,
    width: 20.01,
    height: 26.47,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.3350000000000004
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.005,
    y: 169.40499999999997,
    fontFamily: "Arial"
  }, "\n        Otsego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 182.64,
    width: 20.01,
    height: 28,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.3350000000000004
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.005,
    y: 196.64,
    fontFamily: "Arial"
  }, "\n        Benzie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 210.64,
    width: 20.01,
    height: 28.56,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.3350000000000004
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.005,
    y: 224.92,
    fontFamily: "Arial"
  }, "\n        Baraga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 239.21,
    width: 20.01,
    height: 28.71,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.002000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.005,
    y: 253.565,
    fontFamily: "Arial"
  }, "\n        Alger\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 267.91,
    width: 20.01,
    height: 29.45,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.3350000000000004
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.005,
    y: 282.63500000000005,
    fontFamily: "Arial"
  }, "\n        Arenac\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 297.36,
    width: 20.01,
    height: 31.15,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.2233333333333336
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.005,
    y: 312.935,
    fontFamily: "Arial"
  }, "\n        Roscommon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 328.51,
    width: 20.01,
    height: 31.16,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.8190909090909093
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.005,
    y: 344.09,
    fontFamily: "Arial"
  }, "\n        Schoolcraft\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 359.68,
    width: 20.01,
    height: 33.83,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.3350000000000004
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.005,
    y: 376.595,
    fontFamily: "Arial"
  }, "\n        Ogemaw\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 393.51,
    width: 20.01,
    height: 34.03,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.50125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.005,
    y: 410.525,
    fontFamily: "Arial"
  }, "\n        Leelanau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 427.54,
    width: 20.01,
    height: 35.8,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.858571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.005,
    y: 445.44,
    fontFamily: "Arial"
  }, "\n        Gladwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 463.34,
    width: 20.01,
    height: 36.06,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.50125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.005,
    y: 481.37,
    fontFamily: "Arial"
  }, "\n        Mackinac\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 499.4,
    width: 20.01,
    height: 37.18,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.3350000000000004
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.005,
    y: 517.99,
    fontFamily: "Arial"
  }, "\n        Antrim\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 536.58,
    width: 20.01,
    height: 39.37,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.2233333333333336
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.005,
    y: 556.265,
    fontFamily: "Arial"
  }, "\n        Ontonagon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 575.96,
    width: 20.01,
    height: 39.73,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.002000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.005,
    y: 595.825,
    fontFamily: "Arial"
  }, "\n        Clare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 615.69,
    width: 20.01,
    height: 40.8,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.6675000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.005,
    y: 636.09,
    fontFamily: "Arial"
  }, "\n        Presque_Isle\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 656.5,
    width: 20.01,
    height: 43.5,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.858571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.005,
    y: 678.25,
    fontFamily: "Arial"
  }, "\n        Osceola\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.01,
    y: 0,
    width: 26.19,
    height: 37.28,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.91
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 33.105000000000004,
    y: 18.64,
    fontFamily: "Arial"
  }, "\n        Cheboygan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.19,
    y: 0,
    width: 26.38,
    height: 37.28,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.638
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 59.379999999999995,
    y: 18.64,
    fontFamily: "Arial"
  }, "\n        Charlevoix\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.57,
    y: 0,
    width: 27.67,
    height: 37.28,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.611666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 86.405,
    y: 18.64,
    fontFamily: "Arial"
  }, "\n        Oceana\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100.24,
    y: 0,
    width: 28.47,
    height: 37.28,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.694
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 114.475,
    y: 18.64,
    fontFamily: "Arial"
  }, "\n        Emmet\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128.71,
    y: 0,
    width: 28.91,
    height: 37.28,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.782
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 143.16500000000002,
    y: 18.64,
    fontFamily: "Arial"
  }, "\n        Iosco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 157.62,
    y: 0,
    width: 30.56,
    height: 37.28,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.365714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 172.9,
    y: 18.64,
    fontFamily: "Arial"
  }, "\n        Wexford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 188.18,
    y: 0,
    width: 31.5,
    height: 37.28,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.5
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 203.93,
    y: 18.64,
    fontFamily: "Arial"
  }, "\n        Mecosta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 219.68,
    y: 0,
    width: 34.57,
    height: 37.28,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.6425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 236.965,
    y: 18.64,
    fontFamily: "Arial"
  }, "\n        Iron\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 254.25,
    y: 0,
    width: 34.65,
    height: 37.28,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.33125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 271.575,
    y: 18.64,
    fontFamily: "Arial"
  }, "\n        Manistee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 288.9,
    y: 0,
    width: 40.41,
    height: 37.28,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.456
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 309.10499999999996,
    y: 18.64,
    fontFamily: "Arial"
  }, "\n        Mason\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 329.3,
    y: 0,
    width: 42.67,
    height: 37.28,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.325714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 350.635,
    y: 18.64,
    fontFamily: "Arial"
  }, "\n        Newaygo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 371.98,
    y: 0,
    width: 43.74,
    height: 37.28,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.66
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 393.85,
    y: 18.64,
    fontFamily: "Arial"
  }, "\n        Chippewa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 415.71,
    y: 0,
    width: 43.84,
    height: 37.28,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.142222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 437.63,
    y: 18.64,
    fontFamily: "Arial"
  }, "\n        Menominee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 459.55,
    y: 0,
    width: 46.36,
    height: 37.28,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.142222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 482.73,
    y: 18.64,
    fontFamily: "Arial"
  }, "\n        Dickinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 505.91,
    y: 0,
    width: 46.45,
    height: 37.28,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.325714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 529.135,
    y: 18.64,
    fontFamily: "Arial"
  }, "\n        Gogebic\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 552.36,
    y: 0,
    width: 47.08,
    height: 37.28,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.213333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 575.9,
    y: 18.64,
    fontFamily: "Arial"
  }, "\n        Alpena\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 599.44,
    y: 0,
    width: 48.12,
    height: 37.28,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.66
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 623.5,
    y: 18.64,
    fontFamily: "Arial"
  }, "\n        Isabella\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 647.56,
    y: 0,
    width: 52.44,
    height: 37.28,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.325714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 673.78,
    y: 18.64,
    fontFamily: "Arial"
  }, "\n        Gratiot\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.01,
    y: 37.28,
    width: 46.44,
    height: 42.93,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.155
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.230000000000004,
    y: 58.745000000000005,
    fontFamily: "Arial"
  }, "\n        Branch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.01,
    y: 80.21,
    width: 46.44,
    height: 43.12,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.79111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.230000000000004,
    y: 101.77,
    fontFamily: "Arial"
  }, "\n        Hillsdale\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.01,
    y: 123.33,
    width: 46.44,
    height: 44.88,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.976
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.230000000000004,
    y: 145.77,
    fontFamily: "Arial"
  }, "\n        Huron\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.01,
    y: 168.21,
    width: 46.44,
    height: 44.96,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.992
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.230000000000004,
    y: 190.69,
    fontFamily: "Arial"
  }, "\n        Barry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.01,
    y: 213.17,
    width: 46.44,
    height: 45.1,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.2214285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.230000000000004,
    y: 235.72,
    fontFamily: "Arial"
  }, "\n        Grand_Traverse\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.01,
    y: 258.27,
    width: 46.44,
    height: 45.7,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.528571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.230000000000004,
    y: 281.12,
    fontFamily: "Arial"
  }, "\n        Sanilac\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.01,
    y: 303.97,
    width: 46.44,
    height: 46.7,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.805
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.230000000000004,
    y: 327.32000000000005,
    fontFamily: "Arial"
  }, "\n        Montcalm\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.01,
    y: 350.67,
    width: 46.44,
    height: 47.78,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.288
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.230000000000004,
    y: 374.56,
    fontFamily: "Arial"
  }, "\n        Delta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.01,
    y: 398.45,
    width: 46.44,
    height: 48.17,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.739999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.230000000000004,
    y: 422.53499999999997,
    fontFamily: "Arial"
  }, "\n        Lapeer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.01,
    y: 446.62,
    width: 46.44,
    height: 48.56,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.61
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.230000000000004,
    y: 470.9,
    fontFamily: "Arial"
  }, "\n        Cass\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.01,
    y: 495.18,
    width: 46.44,
    height: 48.72,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.805
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.230000000000004,
    y: 519.54,
    fontFamily: "Arial"
  }, "\n        Houghton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.01,
    y: 543.9,
    width: 46.44,
    height: 48.87,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.634285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.230000000000004,
    y: 568.3349999999999,
    fontFamily: "Arial"
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.01,
    y: 592.77,
    width: 46.44,
    height: 53.07,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.288
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.230000000000004,
    y: 619.305,
    fontFamily: "Arial"
  }, "\n        Ionia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.01,
    y: 645.85,
    width: 46.44,
    height: 54.15,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.644
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.230000000000004,
    y: 672.9250000000001,
    fontFamily: "Arial"
  }, "\n        Livingston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.45,
    y: 37.28,
    width: 39.05,
    height: 65.12,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.905
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.975,
    y: 69.84,
    fontFamily: "Arial"
  }, "\n        St._Joseph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 105.5,
    y: 37.28,
    width: 39.71,
    height: 65.12,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.672857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.355,
    y: 69.84,
    fontFamily: "Arial"
  }, "\n        Tuscola\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.21,
    y: 37.28,
    width: 45.81,
    height: 65.12,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.09
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 168.115,
    y: 69.84,
    fontFamily: "Arial"
  }, "\n        Van_Buren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 191.02,
    y: 37.28,
    width: 48.61,
    height: 65.12,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.401111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 215.32500000000002,
    y: 69.84,
    fontFamily: "Arial"
  }, "\n        Marquette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 239.64,
    y: 37.28,
    width: 50.51,
    height: 65.12,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.051
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 264.895,
    y: 69.84,
    fontFamily: "Arial"
  }, "\n        Shiawassee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 290.15,
    y: 37.28,
    width: 50.63,
    height: 65.12,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.126000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 315.465,
    y: 69.84,
    fontFamily: "Arial"
  }, "\n        Eaton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 340.78,
    y: 37.28,
    width: 50.87,
    height: 65.12,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.267142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 366.215,
    y: 69.84,
    fontFamily: "Arial"
  }, "\n        Midland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 391.65,
    y: 37.28,
    width: 54.48,
    height: 65.12,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.782857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 418.89,
    y: 69.84,
    fontFamily: "Arial"
  }, "\n        Allegan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 446.13,
    y: 37.28,
    width: 66.38,
    height: 65.12,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.302857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 479.32,
    y: 69.84,
    fontFamily: "Arial"
  }, "\n        Lenawee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 512.51,
    y: 37.28,
    width: 89.52,
    height: 65.12,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.853333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 557.27,
    y: 69.84,
    fontFamily: "Arial"
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 602.03,
    y: 37.28,
    width: 97.97,
    height: 65.12,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 21.706666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 651.015,
    y: 69.84,
    fontFamily: "Arial"
  }, "\n        Bay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.45,
    y: 102.4,
    width: 95.95,
    height: 66.54,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.393333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 114.42500000000001,
    y: 135.67000000000002,
    fontFamily: "Arial"
  }, "\n        St._Clair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.45,
    y: 168.94,
    width: 95.95,
    height: 71.32,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.886666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 114.42500000000001,
    y: 204.6,
    fontFamily: "Arial"
  }, "\n        Ottawa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.45,
    y: 240.26,
    width: 95.95,
    height: 78.52,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.217142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 114.42500000000001,
    y: 279.52,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.45,
    y: 318.78,
    width: 95.95,
    height: 82.94,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.848571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 114.42500000000001,
    y: 360.25,
    fontFamily: "Arial"
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.45,
    y: 401.72,
    width: 95.95,
    height: 94.12,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.765
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 114.42500000000001,
    y: 448.78000000000003,
    fontFamily: "Arial"
  }, "\n        Muskegon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.45,
    y: 495.84,
    width: 95.95,
    height: 95.92,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.702857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 114.42500000000001,
    y: 543.8,
    fontFamily: "Arial"
  }, "\n        Berrien\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.45,
    y: 591.76,
    width: 95.95,
    height: 108.24,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.661111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 114.42500000000001,
    y: 645.88,
    fontFamily: "Arial"
  }, "\n        Washtenaw\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162.4,
    y: 102.4,
    width: 97.01,
    height: 107.39,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.77888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 210.905,
    y: 156.095,
    fontFamily: "Arial"
  }, "\n        Kalamazoo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 259.42,
    y: 102.4,
    width: 104.82,
    height: 107.39,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.974285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 311.83000000000004,
    y: 156.095,
    fontFamily: "Arial"
  }, "\n        Saginaw\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 364.23,
    y: 102.4,
    width: 123.69,
    height: 107.39,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.898333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 426.07500000000005,
    y: 156.095,
    fontFamily: "Arial"
  }, "\n        Ingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 487.92,
    y: 102.4,
    width: 212.08,
    height: 107.39,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.34142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 593.96,
    y: 156.095,
    fontFamily: "Arial"
  }, "\n        Genesee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162.4,
    y: 209.79,
    width: 195.97,
    height: 120.18,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 30.045
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 260.385,
    y: 269.88,
    fontFamily: "Arial"
  }, "\n        Kent\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162.4,
    y: 329.97,
    width: 195.97,
    height: 137.79,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 22.965
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 260.385,
    y: 398.865,
    fontFamily: "Arial"
  }, "\n        Macomb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162.4,
    y: 467.76,
    width: 195.97,
    height: 232.24,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 27.995714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 260.385,
    y: 583.88,
    fontFamily: "Arial"
  }, "\n        Oakland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 358.38,
    y: 209.79,
    width: 341.62,
    height: 490.21,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 68.324
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 529.19,
    y: 454.895,
    fontFamily: "Arial"
  }, "\n        Wayne\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1964);
export default __webpack_public_path__ + "static/media/1964.ef55ae38bfdc4e960a074fd6cc8578bd.svg";
export { ForwardRef as ReactComponent };